var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoCall = function SvgIcoCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ico_call_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ico_call_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.44 20.5q-2.827 0-5.68-1.314t-5.242-3.709-3.704-5.242T3.5 4.56A1.03 1.03 0 0 1 4.55 3.5h3.262q.378 0 .668.247t.368.61L9.421 7.3q.06.41-.025.704-.084.293-.304.494l-2.31 2.248q.558 1.02 1.275 1.932.716.91 1.55 1.74a17.2 17.2 0 0 0 3.753 2.842l2.244-2.264q.235-.245.568-.342.334-.099.694-.048l2.776.565q.38.1.619.387.24.285.239.65v3.242q0 .45-.303.75t-.757.3M6.073 9.327l1.785-1.708a.18.18 0 0 0 .062-.106.23.23 0 0 0-.005-.125l-.434-2.234a.2.2 0 0 0-.067-.115A.2.2 0 0 0 7.289 5H5.15a.13.13 0 0 0-.135.135 12.8 12.8 0 0 0 1.058 4.192m8.7 8.642q.994.465 2.074.709t2.018.291a.13.13 0 0 0 .135-.135v-2.103a.2.2 0 0 0-.038-.125.2.2 0 0 0-.116-.068l-2.1-.427a.16.16 0 0 0-.1-.004.25.25 0 0 0-.092.062z"
  }))));
};
export default SvgIcoCall;